'use strict';

var toastr = require('toastr');
var ApproveModalController = function ApproveModalController($scope, pendingUserRequestService, userManagementConstants, $log) {
  $scope.approveUser = function () {
    $scope.user.isActive = true;
    var status = true;
    var message = $scope.approveMessage;
    if ($scope.approveMessage === undefined) {
      message = 'Your request has been approved.';
    }
    $scope.selectedRole = $scope.selectedUser[0].role || $scope.user.roles[0];
    pendingUserRequestService.sendConfirmEmail(status, $scope.user, message);
    pendingUserRequestService.approveUser($scope.user, $scope.user.isActive, $scope.selectedRole).then(function () {
      toastr.success($scope.user.firstName + ' ' + $scope.user.lastName + ' ' + 'request was approved.');
      if ($scope.pendingNumbers === 1) {
        $scope.$emit('user-management-manage-users:change-screen', userManagementConstants.SCREEN_VALUE.MANAGE_USERS);
      } else {
        $scope.$emit('user-management-manage-users:change-screen', userManagementConstants.MANAGE_USERS_SCREENS.MANAGE_ACCESS_REQUESTS);
      }
      $scope.hideApproveModal();
    })["catch"](function () {
      $log.error('ApproveModalController: pendingUserRequestService.approveUser - Error: Can not be approved');
      toastr.error('Error: Can not be approved');
    });
  };
};
ApproveModalController.$inject = ['$scope', 'PendingUserRequestService', 'UserManagementConstants', '$log'];
module.exports = ApproveModalController;